import { Card } from "../components/Card";
import { PageHeader } from "../components/PageHeader";
import { launchCities } from "../lib/constants";

export function Coverage() {
  return (
    <>
      <PageHeader
        eyebrow="نطاق التغطية عند الإطلاق"
        title="المدن المشمولة في نسخة MVP"
        description="يتم استقبال الطلبات عند الإطلاق في أربع مدن فقط، ويمكن توسيع النطاق لاحقاً بعد اعتماد التشغيل."
      />
      <section className="py-20">
        <div className="container grid gap-4 md:grid-cols-4">
          {launchCities.map((city) => (
            <Card key={city}>
              <h2 className="text-center text-2xl font-bold text-charcoal">{city}</h2>
            </Card>
          ))}
        </div>
      </section>
    </>
  );
}
